module.exports = ".configuracion-credito{position:relative}.configuracion-credito .alert.active{top:-12px}\n"